import {
    Box,
    Typography,

} from "@mui/material";
import FotterComponent from "../Components/FotterComponent";
import HeaderComponent from "../Components/HeaderCoponent";

function ExperianConsent() {
    return (
        <>
            <HeaderComponent/>
             <Box style={{ marginTop: "20px" }}>
                      <Box
                        style={{
                          width: "100%",
                          height: "198px",
                          background: "rgba(32, 175, 229, .16)",
                          // paddingTop: "100px",
                          // paddingBottom: "50px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "24px",
                            fontWeight: "400",
                            fontFamily: "CustomFontMedium",
                          }}
                        >
                         Experian-consent
                        </Typography>
                      </Box>
                    </Box>

            <Box
                sx={{
                    padding: "20px",
                    flexGrow: 1,
                    overflowY: "auto", // Allow scrolling within this box
                    paddingRight: "10px", // Add some padding to prevent the scrollbar from overlapping content
                }}
            >
                

                <Typography
                    id="modal-title"
                    variant="h6"
                    component="h2"
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        color: "black",
                        marginTop: "10px",
                    }}
                >
                    <strong style={{ textDecoration: "underline" }}>
                        {" "}
                        {/* Terms and Conditions: */}
                        CONSENT IN RELATION TO ACCESS TO CREDIT INFORMATION THROUGH EXPERIAN
                    </strong>
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    This End User Agreement (the “<strong>Agreement</strong>”) is made between you (the “<strong>User</strong>”) and Due Factory Services Private Limited
                    (hereinafter referred to as “Client”), a private limited company having its registered office at 806-807, Udyog Vihar Phase V,
                    Sector 19, Gurugram, Haryana – 122016 ( “<strong>CLIENT</strong>”,  “<strong>Us</strong>”,  or  “<strong>We</strong>” , which term shall include its successors and permitted assigns).
                    The User and CLIENT shall be collectively referred to as the “<strong>Parties</strong>”  and individually as a “<strong>Party</strong>” .
                </Typography>

                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                        fontWeight: "bold"
                    }}
                >
                    BY EXECUTING THIS AGREEMENT / CONSENT FORM, YOU ARE EXPRESSLY AGREEING TO ACCESS THE EXPERIAN CREDIT INFORMATION REPORT AND CREDIT SCORE, AGGREGATE SCORES, INFERENCES, REFERENCES AND DETAILS (AS DEFINED BELOW) (TOGETHER REFERRED AS “CREDIT INFORMATION”). YOU HEREBY ALSO CONSENT TO SUCH CREDIT INFORMATION BEING PROVIDED BY EXPERIAN TO YOU AND CLIENT BY USING EXPERIAN TOOLS, ALGORITHMS AND DEVICES AND YOU HEREBY AGREE, ACKNOWLEDGE AND ACCEPT THE TERMS AND CONDITIONS SET FORTH HEREIN
                </Typography>
                <Typography
                    id="modal-title"
                    variant="h6"
                    component="h2"
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        color: "black",
                        marginTop: "10px",
                    }}
                >
                    <strong style={{ textDecoration: "underline" }}>
                        {" "}
                        Terms and Conditions:
                    </strong>
                </Typography>

                <Typography
                    id="modal-title"
                    variant="h6"
                    component="h2"
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        color: "black",
                        marginTop: "10px",
                    }}
                >
                    {/* here */}
                    <strong>
                        {" "}
                        Information Collection, Use, Confidentiality, No-Disclosure and Data Purging
                    </strong>
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    CLIENT shall access your Credit Information as your authorized representative and CLIENT shall use the Credit Information for limited End Use Purpose consisting of and in relation to the services proposed to be availed by you from CLIENT. We shall not aggregate, retain, store, copy, reproduce, republish, upload, post, transmit, sell or rent the Credit Information to any other person and the same cannot be copied or reproduced other than as agreed herein and in furtherance to CICRA.
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    The Parties agree to protect and keep confidential the Credit Information both online and offline.
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    The Credit Information shared by you or received on by us on your behalf shall be destroyed, purged, erased promptly of upon the completion of the transaction/ End Use Purpose for which the Credit Information report was procured for up to a maximum of 6 months.
                </Typography>
                <Typography
                    id="modal-title"
                    variant="h6"
                    component="h2"
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        color: "black",
                        marginTop: "10px",
                    }}
                >
                    <strong>Governing Law and Jurisdiction</strong>
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    The relationship between you and CLIENT shall be governed by laws of India and all claims or disputes arising there from shall be subject to the exclusive jurisdiction of the courts of Mumbai.
                </Typography>
                <Typography
                    id="modal-title"
                    variant="h6"
                    component="h2"
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        color: "black",
                        marginTop: "10px",
                    }}
                >
                    <strong>Definitions:</strong>
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    Capitalized terms used herein but not defined above shall have the following meanings:
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    “<strong>Business Day</strong>” means a day (other than a
                    public holiday) on which banks are open for general business
                    in Mumbai.
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    “<strong>Credit Information Report</strong>” means the
                    credit information / scores/ aggregates / variables /
                    inferences or reports which shall be generated by Experian;

                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    “<strong>Credit Score</strong>” means the score which shall
                    be mentioned on the Credit Information Report which shall be
                    computed by Experian.
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    “<strong>CICRA</strong>” shall mean the Credit Information Companies (Regulation) Act, 2005 read with the Credit Information Companies Rules, 2006 and the Credit Information Companies Regulations, 2006, and shall include any other rules and regulations prescribed thereunder.
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    PLEASE READ THE ABOVEMENTIONED TERMS AND CONDITIONS AND CLICK ON “ACCEPT” FOLLOWED BY THE LINK BELOW TO COMPLETE THE AUTHORISATION PROCESS/  FOR SHARING OF YOUR CREDIT INFORMATION BY EXPERIAN WITH CLIENT IN ITS CAPACITY AS YOUR AUTHORISED REPRESENTATIVE
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    BY CLICKING “ACCEPT” YOU AGREE AND ACCEPT THE DISCLAIMERS AND TERMS AND CONDITIONS SET OUT HEREIN.
                </Typography>
                <Typography
                    style={{
                        fontSize: "13px",
                        fontFamily: "CustomFontMedium",
                        marginTop: "10px",
                    }}
                >
                    ** This document is an electronic record in terms of the Information Technology Act, 2000 and Rules made there under, and the amended provisions pertaining to electronic records.
                </Typography>
            </Box>
            <FotterComponent />
        </>
    )
}

export default ExperianConsent